/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { DeleteOutlined, EditOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Col, Row, Space, Image, Input } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { appConfig, themeConfig } from 'config'
import { BannerListReq, DeleteBannerReq } from 'Store/banner/types'
import { bannerListAPI, deleteBannerAPI } from 'Store/banner/api'
import { selectbannerActionEvent, selectBannerList, selectBannerListEvent } from 'Store/banner/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { clearEventAction } from 'Store/banner/actions'
import { bannerPositionText, getBannerStatus } from 'helpers/format'
import { StatusTag } from 'Components/utilities'
import { BannerPosition, BannerStatus, ImageFallback } from 'helpers/constanst'
import { ConfirmDailog } from 'Components/modal'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import BannerDetail from './detail'
import EventModal from 'Components/modal/EventModal'
import { Pagination } from 'Components/Pagination'

type Props = {} & ReduxProps

const HilightBanner: React.FunctionComponent<Props> = props => {
  const { currentUser, bannerListEvent, bannerList, event } = props
  const dispatch = useDispatch()
  const [drawer, setDrawer] = useState(false)
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const [pageMode, setPageMode] = useState('create' as 'create' | 'edit' | 'deleted')

  const [filter, setFilter] = useState({
    keyword: '',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const meta = bannerList.meta
  const datas = bannerList.data

  const onGetBannerList = (): void => {
    const req: BannerListReq = {
      page: pagination.Page,
      keyword: filter.keyword?.trim() || '',
      per_page: pagination.RowPerPage,
      paging: true,
    }
    dispatch(bannerListAPI(req, currentUser.accessToken))
  }

  const onDeleteBanner = (id: number): void => {
    const req: DeleteBannerReq = {
      id,
    }
    dispatch(deleteBannerAPI(req, currentUser.accessToken))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetBannerList()
    }
  }, [pagination])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const onOpenDrawer = () => {
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
  }

  const onOpenConfirmDelete = () => {
    setConfirmDeleteDialog(true)
  }

  const onCloseConfirmDelete = () => {
    setConfirmDeleteDialog(false)
  }

  const onClickCreate = () => {
    setPageMode('create')
    setSelectedID(0)
    onOpenDrawer()
  }

  const onClickEdit = (id: number) => {
    setPageMode('edit')
    setSelectedID(id)
    onOpenDrawer()
  }

  const onClickDelete = (id: number) => {
    setPageMode('deleted')
    setSelectedID(id)
    onOpenConfirmDelete()
  }

  const onConfirmDelete = () => {
    onDeleteBanner(selectedID)
    onCloseConfirmDelete()
  }

  const onSuccess = () => {
    onCloseDrawer()
    onGetBannerList()
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onDeleteSuccess = (): void => {
    clearEvent()
    onGetBannerList()
  }

  const renderImage = (img: string) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + img} fallback={ImageFallback} />
  )

  const renderBannerStatus = (status: BannerStatus) => (
    <StatusTag isPass={status === BannerStatus.PUBLISH} text={getBannerStatus(status)} />
  )

  const renderActionButton = (text: string, record: any) => (
    <Space size="middle">
      <ActionButton
        text=""
        icon={<EditOutlined />}
        label="แก้ไข"
        action="edit"
        onClick={() => onClickEdit(record.id)}
      />
      <ActionButton
        text=""
        icon={<DeleteOutlined />}
        label="ลบ"
        action="deleted"
        onClick={() => onClickDelete(record.id)}
      />
    </Space>
  )

  const columns = [
    {
      title: 'รูปภาพ',
      dataIndex: 'banner',
      key: 'banner',
      width: '150px',
      render: renderImage,
    },
    {
      title: 'ชื่อแบนเนอร์',
      dataIndex: 'name',
      key: 'name',
      width: '25%',
    },
    {
      title: 'ตำแหน่ง',
      dataIndex: 'position',
      key: 'position',
      render: (position: BannerPosition) => bannerPositionText(position),
    },
    {
      title: 'ลำดับการแสดงผล',
      dataIndex: 'no',
      key: 'no',
    },
    {
      title: 'สถานะ',
      key: 'status',
      dataIndex: 'status',
      render: renderBannerStatus,
    },
    {
      title: 'แก้ไข/ลบ',
      key: 'action',
      render: renderActionButton,
    },
  ]

  const DetailDrawer = (
    <BannerDetail
      mode={pageMode}
      id={selectedID}
      visible={drawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
    />
  )

  const LoadingModal = (
    <EventModal
      event={[event]}
      enable={pageMode === 'deleted'}
      successCalback={onDeleteSuccess}
      errorCalback={clearEvent}
    />
  )

  const ConfirmDeleteModal = (
    <ConfirmDailog
      isShow={confirmDeleteDialog}
      handleOk={onConfirmDelete}
      handleCancel={onCloseConfirmDelete}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="bottom">
        <MyCol xs={24} md={12}>
          <Space size="middle" align="end">
            <SearchInput
              placeholder="ค้นหาชื่อแบนเนอร์"
              prefix={<SearchOutlined />}
              allowClear
              value={filter.keyword}
              onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
            />
            <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
          </Space>
        </MyCol>
        <MyCol>
          <Space size="middle">
            <PrimaryButton text="เพิ่มแบนเนอร์" icon={<PlusOutlined />} onClick={onClickCreate} />
          </Space>
        </MyCol>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  return (
    <>
      <HomePageLayout
        selected="banners"
        title="ไฮไลต์แบนเนอร์"
        label={`รายการไฮไลต์ผลิตภัณฑ์ ที่ทางร้านต้องการนำเสนอไปที่หน้าแรกของ ${themeConfig.title.appName}`}
      >
        {FilterContent}
        <TableListPage
          columns={columns}
          datas={datas}
          isLoading={bannerListEvent.IsLoading}
          paginationContent={PaginationContent}
        />
        {LoadingModal}
        {DetailDrawer}
        {ConfirmDeleteModal}
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    bannerList: selectBannerList(state),
    bannerListEvent: selectBannerListEvent(state),
    event: selectbannerActionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const MyCol = styled(Col)`
  margin-top: 10px;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 100%;
  height: 50px;
  object-fit: cover;
`

export default connect(mapStateToProps)(HilightBanner)
